import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import datas from './datas'
import user from './user'
import upload from './upload'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    datas,
    user,
    upload,
  },
  plugins: [
    createPersistedState({
      paths: ['datas', 'user', 'route'],
      arrayMerger(store, saved) {
        // Keep only value from user input, update structure
        return store.map((d,i) => {
          return {
            ...d,
            value: saved[i] && saved[i].value
          }
        })
      }
    }),
    (store) => {
      store.subscribeAction((action) => {
        action.type !== 'breathe' && store.dispatch('breathe')
      })
    }
  ]
})
